import { GenericChartComponent, getStrokeDasharrayCanvas, noop } from 'react-financial-charts';
import * as React from 'react';
import type { StraightLineProps } from './InteractiveStraightLine';
import { InteractiveStraightLine } from './InteractiveStraightLine';
import type { MoreProps } from '../../../../types/commontypes';
// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
const ChartComponent = GenericChartComponent as unknown as React.ComponentType<Record<string, unknown>>;

export class FilledArea extends React.Component<StraightLineProps> {
  public static defaultProps = {
    onEdge1Drag: noop,
    onEdge2Drag: noop,
    edgeStrokeWidth: 2,
    edgeStroke: '#1e53e6',
    edgeFill: '#FFFFFF',
    r: 5,
    withEdge: false,
    strokeWidth: 1,
    strokeDasharray: 'Solid',
    children: noop,
    tolerance: 7,
    selected: false,
    extendLeft: false,
    extendRight: false,
  };

  public render() {
    const { selected, interactiveCursorClass, onDoubleClick } = this.props;
    return (
      <ChartComponent
        interactive={false}
        // isHover={this.isHover}
        canvasToDraw={undefined}
        canvasDraw={this.drawOnCanvas}
        interactiveCursorClass={interactiveCursorClass}
        selected={selected}
        drawOn={['mousemove', 'pan', 'drag']}
        disablePan={false}
        clip={true}
        onDoubleClick={onDoubleClick}
      />
    );
  }
  private readonly drawOnCanvas = (ctx: CanvasRenderingContext2D, moreProps: MoreProps) => {
    const {
      strokeWidth = InteractiveStraightLine.defaultProps.strokeWidth,
      strokeDasharray,
      strokeStyle,
      fillStyle,
      x3Value,
      y3Value,
    } = this.props;

    const result = helper(this.props, moreProps);
    if (result == null) return;
    const { topLeftX, topRightX, bottomLeftX, bottomRightX, y1, y2, x1, x2, x3, y3 } = result;

    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = strokeStyle;
    ctx.fillStyle = fillStyle || 'rgba(156, 39, 176, 0.2)';
    const lineDash = getStrokeDasharrayCanvas(strokeDasharray);
    ctx.setLineDash(lineDash);

    ctx.beginPath();

    if (x3Value !== undefined && y3Value !== undefined && x3 !== undefined && y3 !== undefined) {
      // Draw Triangle
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.lineTo(x3, y3);
      ctx.closePath();
    } else {
      // Draw Rectangle (current logic)
      ctx.moveTo(topLeftX, y1); // Top-left
      ctx.lineTo(bottomLeftX, y2); // Bottom-left
      ctx.lineTo(bottomRightX, y2); // Bottom-right
      ctx.lineTo(topRightX, y1); // Top-right
      ctx.closePath();
    }

    ctx.fill();
  };
}

function helper(props: StraightLineProps, moreProps: MoreProps) {
  const {
    xScale,
    chartConfig: { yScale },
  } = moreProps;

  const { x1Value, x2Value, y1Value, y2Value, x3Value, y3Value, extendLeft, extendRight } = props;

  if (x1Value == null || x2Value == null || y1Value == null || y2Value == null) {
    return null;
  }

  const x1 = xScale(x1Value);
  const x2 = xScale(x2Value);
  const y1 = yScale(y1Value);
  const y2 = yScale(y2Value);

  let x3, y3;
  if (x3Value !== undefined && y3Value !== undefined) {
    x3 = xScale(x3Value);
    y3 = yScale(y3Value);
  }

  const [startX, endX] = xScale.range();

  const leftX = Math.min(x1, x2);
  const rightX = Math.max(x1, x2);

  const topLeftX = extendLeft ? startX : leftX;
  const topRightX = extendRight ? endX : rightX;
  const bottomLeftX = extendLeft ? startX : leftX;
  const bottomRightX = extendRight ? endX : rightX;

  return {
    topLeftX,
    topRightX,
    bottomLeftX,
    bottomRightX,
    y1,
    y2,
    x1,
    x2,
    x3,
    y3,
  };
}
